import React, { FunctionComponent } from "react";

const HomePage: FunctionComponent = () => (
  <div>
    Home!
  </div>
);

export default HomePage;
